import React from 'react';
import ReactSVG from "react-svg";
import {usePages} from "@ignitesales/neuro-application";
import PropTypes from "prop-types";

const LoadingDataIcon = ({shouldWaitForAnimation = true }) => {
    const { isLoadingNextPage, isAnimatingPages } = usePages();
    const shouldRender = isLoadingNextPage || ( shouldWaitForAnimation && isAnimatingPages);
    return shouldRender ? <ReactSVG src='/classpath/assets/images/loading.svg' className='loading-page-icon loadingDataIcon' /> : null;
};
LoadingDataIcon.propTypes = {
    shouldWaitForAnimation: PropTypes.bool
};

export default LoadingDataIcon;
